/**
 * The pieces every /earthworks screen draws the same way.
 *
 * IMPORTED, not copied: the register, chips, badge, panel, field and input are
 * the NDT screens' (as Pipeline & Facility's are), so the verticals stay one
 * shape. Nothing in those files is edited by this vertical.
 */
export {
  NdtBadge as EwBadge,
  NdtChip as EwChip,
  NdtChipRow as EwChipRow,
  NdtDialog as EwDialog,
  NdtEmpty as EwEmpty,
  NdtField as EwField,
  NdtFormError as EwFormError,
  NdtLoading as EwLoading,
  NdtPanel as EwPanel,
  NdtRegister as EwRegister,
  NdtSpec as EwSpec,
  NDT_INPUT as EW_INPUT,
  NDT_PRIMARY as EW_PRIMARY,
  NDT_SECONDARY as EW_SECONDARY,
  NDT_DATE_INPUT as EW_DATE_INPUT,
  isNotFound,
  type NdtColumn as EwColumn,
} from '../ndt-inspection/NdtBits';

export const EW_EYEBROW = 'Earthworks';
